import { Component } from '@angular/core';
import { SearchParams } from '../../search/models/search-params.model';
import { SearchStatus } from '../../search/models/search-status.model';
import { SearchService } from '../../search/search.service';
import { SharedServiceRegistry } from '../../shared-service-registry';
import { CoreServiceRegistry } from '../../../core/core-service-registry';
import { SearchableEntityDataEditorService } from '../../services/searchable-entity/searchable-entity-data-editor.service';
import { DataTableConfig } from '../../search/models/data-table-config';
import { Clause, Condition, SearchCriteria } from '../../search/models/search-filter-model';
import { DISPLAY_MODE, SEARCH_KEYS } from '../../../constants';

@Component({
  selector: 'lfwms-wave-control-lane-popup',
  templateUrl: './wave-control-lane-popup.component.html',
  styleUrls: ['./wave-control-lane-popup.component.css']
})
export class WaveControlLanePopupComponent {
  public searchAccordionTitle;
  public searchParams: SearchParams;
  public lookupStatus: SearchStatus;
  public lookupSearchService: SearchService;
  public tableId: string = 'loadlaneloctd';
  public loadKey: string = '';
  
  constructor(
    private readonly sharedServiceRegistry: SharedServiceRegistry,
    private readonly coreServiceRegistry: CoreServiceRegistry
  ) { }

  initializeComponents(loadKey: string) {
    this.loadKey = loadKey;
    this.lookupSearchService = this.createSearchService();
    const searchParams = this.lookupSearchService.searchParams;
    this.searchParams = searchParams;
    this.lookupSearchService.setSearchCriteria(this.createSearchCriteria());
    this.lookupSearchService.performSearch();
  }
  
  createSearchService():  SearchService {
    this.lookupStatus = new SearchStatus();
    const searchParams = new SearchParams();
    searchParams.tableId = this.tableId;
    searchParams.isFullFetch = true;
    searchParams.alertService = this.sharedServiceRegistry.alertService;
    searchParams.tableEditor = new SearchableEntityDataEditorService(
      this.coreServiceRegistry,
      this.sharedServiceRegistry
    );
    searchParams.dataTableConfig = new DataTableConfig();
    searchParams.dataTableConfig.editable = true;
    searchParams.dataTableConfig.showIdAsAHyperLink = true;
    
    const searchService = this.sharedServiceRegistry.createSearchService(searchParams, this.lookupStatus);
    return searchService;
  }

  createSearchCriteria() {
    const defaultSearchCriteria = new SearchCriteria();
    defaultSearchCriteria.conditions = [];
    defaultSearchCriteria.loadDefaultCriteria = false;

    const defaultCondition = this.createSearchCondition(1);
    const defaultClause = new Clause();
    defaultClause.column = SEARCH_KEYS.LOAD_KEY;
    defaultClause.value = this.loadKey;
    defaultClause.operation = '=';
    defaultCondition.clauses = [defaultClause];

    defaultSearchCriteria.conditions.push(defaultCondition);

    return defaultSearchCriteria;
  }

  createSearchCondition(id: any): Condition {
    const defaultCondition = new Condition();
    defaultCondition.id = id;
    defaultCondition.displayMode = DISPLAY_MODE.VIEW;
    defaultCondition.isReadOnly = true;
    defaultCondition.isMandatory = true;
    return defaultCondition;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/lookup/wave-control-lane-popup/wave-control-lane-popup.component.ts